import compose from 'recompose/compose';
import branch from 'recompose/branch';
import renderNothing from 'recompose/renderNothing';
import WithInstantExperiences from './WithInstantExperiences';

const preventRenderForEmbeddedMode = compose(
  WithInstantExperiences,
  branch(
    props => props.instantExperiences,
    renderNothing,
  ),
);

export default preventRenderForEmbeddedMode;



// WEBPACK FOOTER //
// ./src/app/hoc/preventRenderForEmbeddedMode.js